import { Component, OnInit } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { AppRoutes } from "src/app/constants";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import * as UserActions from "src/app/store/user/actions";
import * as FromUser from "src/app/store/user/selectors";
import { Observable } from "rxjs";
import { Browser } from "@capacitor/browser";

@Component({
  selector: "app-confirm-registration",
  templateUrl: "./confirm-registration.page.html",
  styleUrls: ["./confirm-registration.page.scss"],
})
export class ConfirmRegistrationPage implements OnInit {
  public loading$: Observable<boolean> = this.store.select(FromUser.selectLoading);
  public routes: typeof AppRoutes = AppRoutes;
  public token = this.activatedRoute.snapshot.queryParamMap.get("token");

  constructor(private menu: MenuController, private store: Store<RootState>, private activatedRoute: ActivatedRoute) {
    this.menu.enable(false);
  }

  public ngOnInit(): void {
    this.store.dispatch(UserActions.setAccessToken({ accessToken: this.token }));
    this.store.dispatch(UserActions.confirmRegistration());
  }

  public openHelp(): void {
    Browser.open({ url: "https://hilfe.wowfamily.de" });
  }
}
